/**
 *  区分是浏览器打开还是app内打开（利用useragent,android约定返回字符串location-android,ios返回location-ios）
 */
export const isApp = () => {
  const UA = navigator.userAgent.toLowerCase();
  if (UA === 'location-android') {
    return true;
  } else if (UA === 'location-ios') {
    return true;
  } else {
    return false;
  }
};

/**
 *  是否android app
 */
export const isAppAndroid = () => {
  const UA = navigator.userAgent.toLowerCase(); // crm-android ,crm-ios
  return UA === 'location-android';
};

/**
 *  是否ios app
 */
export const isAppIOS = () => {
  const UA = navigator.userAgent.toLowerCase(); // crm-android ,crm-ios
  return UA === 'location-ios';
};

/**
 *  是否是企微环境
 */
export const isWeComEnv = () => {
  return window.navigator.userAgent.includes('wxwork');
};

